import { initialState } from './reducer';

export interface ICookieSettingsStore {}

export function getInitialCookieSettingsStore(): ICookieSettingsStore {
  return { ...initialState };
}
